import { useEffect, useState } from 'react';
import { i18n } from '@ankr.com/raas-utils';

import { locales } from '../const';
import { Locale } from '../types';
import { useLocale } from './useLocale';

interface IUseLocaleInit {
  isLocaleReady: boolean;
}

export const useLocaleInit = (): IUseLocaleInit => {
  const [isLocaleReady, setLocaleReady] = useState(false);

  const { locale } = useLocale();

  useEffect(() => {
    setLocaleReady(false);

    async function loadLocale(): Promise<void> {
      await i18n.init({
        lng: locale,
        fallbackLng: Locale.en,
        interpolation: {
          escapeValue: false,
        },
        nsSeparator: ':::',
        returnObjects: true,
        resources: {
          en: {
            translation: locales[Locale.en],
          },
        },
      });

      setLocaleReady(true);
    }

    void loadLocale();
  }, [locale]);

  return {
    isLocaleReady,
  };
};
